import dayjs from 'dayjs'
import React from 'react'
import Calendar from 'react-calendar'
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@fr8/frui"
// Define the correct type for value (react-calendar uses this structure)
type CalendarValue = Date | null | [Date | null, Date | null]

const toDate = dayjs().toDate()

interface IPeriod {
  open: boolean
  onOpenChange: (open: boolean) => void
  range: { show: boolean; startDate: string; endDate: string }
  setRange: (range: { show: boolean; startDate: string; endDate: string }) => void
  onSelect: (type: string, range: string[]) => void
}

const PeriodRange = ({ open, onOpenChange, range, setRange, onSelect }: IPeriod) => {
  const [value, setValue] = React.useState<CalendarValue>([toDate, toDate])

  React.useEffect(() => {
    if (range.startDate && range.endDate) {
      setValue([dayjs(range.startDate).toDate(), dayjs(range.endDate).toDate()])
    }
  }, [range.startDate, range.endDate])

  const handleChange = (v: CalendarValue) => {
    if (Array.isArray(v) && v[0] && v[1]) {
      setRange({
        ...range,
        startDate: dayjs(v[0]).format('YYYY-MM-DD'),
        endDate: dayjs(v[1]).format('YYYY-MM-DD'),
      })
    }
    setValue(v)
  }

  const handleSelect = () => {
    onSelect('CUSTOM', [range.startDate, range.endDate])
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Select Date Range</DialogTitle>
        </DialogHeader>
        <div>
          <p>Start Date: <b>{range.startDate || '-'}</b></p>
          <p>End Date: <b>{range.endDate || '-'}</b></p>
        </div>
        <Calendar
          onChange={handleChange}
          value={value}
          selectRange
        />
        <DialogFooter>
          <Button
            disabled={!range.startDate || !range.endDate}
            variant="outline"
            onClick={handleSelect}
          >
            Select
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PeriodRange;
